import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/lib/auth";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => { setPosts(r.data || []); setLoading(false); });
  }, []);

  return (
    <div data-testid="page-blog" className="pt-32 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="max-w-2xl">
          <div className="overline">Journal</div>
          <h1 className="font-display text-5xl sm:text-6xl mt-3 tracking-tight text-balance">
            Notes from the salon.
          </h1>
          <p className="mt-6 text-lg text-[hsl(var(--onyx)/0.65)] leading-relaxed">
            Extension aftercare, career advice for stylists, colour trends and the story behind NøoksProRange.
          </p>
        </div>

        {loading ? (
          <div className="mt-16 text-[hsl(var(--onyx)/0.5)]">Loading posts…</div>
        ) : posts.length === 0 ? (
          <div className="mt-16 rounded-3xl bg-white border border-dashed border-[hsl(var(--onyx)/0.15)] p-12 text-center text-[hsl(var(--onyx)/0.55)]">
            First post coming soon.
          </div>
        ) : (
          <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block rounded-3xl overflow-hidden bg-white border border-[hsl(var(--onyx)/0.06)] hover:shadow-[0_20px_60px_-30px_rgba(20,10,15,0.2)] transition-shadow"
              >
                {p.cover_image && (
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6">
                  {p.tags && p.tags.length > 0 && (
                    <div className="text-[10px] uppercase tracking-widest text-[hsl(var(--gold))] mb-2">
                      {p.tags.slice(0, 2).join(" · ")}
                    </div>
                  )}
                  <h3 className="font-display text-2xl leading-tight tracking-tight">{p.title}</h3>
                  {p.excerpt && (
                    <p className="mt-3 text-sm text-[hsl(var(--onyx)/0.65)] leading-relaxed line-clamp-3">
                      {p.excerpt}
                    </p>
                  )}
                  <div className="mt-4 flex items-center gap-2 text-xs text-[hsl(var(--onyx)/0.5)]">
                    {p.published_at && <span>{new Date(p.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</span>}
                    <ArrowUpRight size={12} className="ml-auto group-hover:translate-x-0.5 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
